
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pocasi",
      function () {
        return require("private-next-pages/[region]/[resort]/pocasi.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pocasi"])
      });
    }
  